import { render, staticRenderFns } from "./myGroupCustomer.vue?vue&type=template&id=20eabdc6&"
import script from "./myGroupCustomer.vue?vue&type=script&lang=js&"
export * from "./myGroupCustomer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('20eabdc6')) {
      api.createRecord('20eabdc6', component.options)
    } else {
      api.reload('20eabdc6', component.options)
    }
    module.hot.accept("./myGroupCustomer.vue?vue&type=template&id=20eabdc6&", function () {
      api.rerender('20eabdc6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/cargo/v0/Sales/myGroupCustomer.vue"
export default component.exports